"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function CompanyHistoryAndValues() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: img1Ref,
    isVisible: img1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: img2Ref,
    isVisible: img2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: img3Ref,
    isVisible: img3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: img4Ref,
    isVisible: img4Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="text-white py-24 px-6 !bg-transparent md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {}
          <div className="space-y-12">
            <div ref={section1Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${section1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <h2 className="font-display text-4xl font-bold mb-6 !text-[hsl(22,78%,26%)] md:text-5xl">
                Our Heritage
              </h2>
              <p className="text-lg leading-relaxed text-muted-foreground !text-justify">
                Founded in the heart of Dubai, Salem Ballama Auditing has been a cornerstone of financial
                integrity and regulatory compliance in the UAE for over two decade.&nbsp;
                <div>
                  We combine international auditing standards with deep local market expertise to serve
                  high-net-worth individuals and corporate entities across the region.
                </div>
              </p>
            </div>

            <div ref={section2Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-75 ${section2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <h3 className="font-display text-3xl font-semibold mb-4 !text-[hsl(22,78%,26%)]">
                Our Values
              </h3>
              <ul className="space-y-3 text-lg text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-gray-900 mr-3 mt-1">•</span>
                  <span className="!text-left">
                    <strong className="!text-[hsl(22,78%,26%)]">Integrity:</strong> Upholding the highest
                    ethical standards in every engagement.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-900 mr-3 mt-1">•</span>
                  <span>
                    <strong className="!text-[hsl(22,78%,26%)]">Excellence:</strong> Delivering meticulous
                    audits and strategic tax advisory with precision.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-900 mr-3 mt-1">•</span>
                  <span>
                    <strong className="!text-[hsl(22,78%,26%)]">Trust:</strong> Building lasting relationships
                    through transparency and reliability.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-900 mr-3 mt-1">•</span>
                  <span>
                    <strong className="!text-[hsl(22,78%,26%)]">Local Expertise:</strong> Navigating UAE
                    regulations with unmatched regional knowledge.
                  </span>
                </li>
              </ul>
            </div>

            <div ref={section3Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-150 ${section3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <h3 className="font-display text-3xl font-semibold mb-4 !text-[hsl(22,78%,26%)]">
                Commitment to Excellence
              </h3>
              <p className="text-lg leading-relaxed text-muted-foreground !text-justify">
                Every audit, every tax filing, and every consultation reflects our unwavering commitment to
                the Gold Standard of professional services. We are trusted advisors to enterprises navigating
                future of the financial landscape of the UAE and beyond.
              </p>
            </div>
          </div>

          {}
          <div className="relative h-full min-h-[600px]">
            <div className="relative w-full h-full">
              {}
              <div ref={img1Ref} className={`absolute top-0 left-0 w-3/5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${img1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
                <Card className="overflow-hidden border-2 border-primary shadow-medium hover:border-primary-hover hover:shadow-strong hover:-translate-y-0.5 transition-all duration-[80ms]">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/salem_ballama_professional_team_collaboration_dubai.png" alt="Salem Ballama Auditing professional team collaboration and strategic planning in Dubai" className="w-full h-64 object-cover" />
                </Card>
              </div>

              {}
              <div ref={img2Ref} className={`absolute top-20 right-0 w-3/5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-75 ${img2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
                <Card className="overflow-hidden border-2 border-primary shadow-medium hover:border-primary-hover hover:shadow-strong hover:-translate-y-0.5 transition-all duration-[80ms]">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/salem_ballama_executive_boardroom_meeting.png" alt="Salem Ballama Auditing executive boardroom during strategic planning session" className="w-full h-56 object-cover" />
                </Card>
              </div>

              {}
              <div ref={img3Ref} className={`absolute bottom-32 left-8 w-1/2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-150 ${img3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
                <Card className="overflow-hidden border-2 border-primary shadow-medium hover:border-primary-hover hover:shadow-strong hover:-translate-y-0.5 transition-all duration-[80ms]">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/salem_ballama_financial_analysis_consultation.png" alt="Professional financial analysis and consultation at Salem Ballama Auditing" className="w-full h-48 object-cover" />
                </Card>
              </div>

              {}
              <div ref={img4Ref} className={`absolute bottom-0 right-4 w-3/5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-[225ms] ${img4Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
                <Card className="overflow-hidden border-2 border-primary shadow-medium hover:border-primary-hover hover:shadow-strong hover:-translate-y-0.5 transition-all duration-[80ms]">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/salem_ballama_professional_audit_team_dubai_office.png" alt="Salem Ballama Auditing professional audit team working in Dubai office" className="w-full h-60 object-cover" />
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}